import { environment } from "@environments/environment";
import * as Sentry from "@sentry/angular";

export const SentryConfig: Sentry.BrowserOptions = {
  environment: 'production',
  release: environment.version,
  beforeSend(event) {
    const allowedHosts = [environment.deployUrl];

    // Get stacktrace frames from the first exception (if any)
    const frames = event?.exception?.values?.[0]?.stacktrace?.frames || [];

    // If no frames, allow the event
    if (frames.length === 0) {
      return event;
    }

    // Check if any frame is from allowed host
    const isFromAllowedHost = frames.some(frame =>
      allowedHosts.some(host =>
        frame.filename && frame.filename.includes(host)
      )
    );

    // Prevent throwing error from other domains
    if (!isFromAllowedHost) {
      return null;
    }

    return event;
  },
  dsn: environment.sentryDsn,
  integrations: [
    // Registers and configures the Tracing integration,
    // which automatically instruments your application to monitor its
    // performance, including custom Angular routing instrumentation
    Sentry.browserTracingIntegration(),
    // Registers the Replay integration,
    // which automatically captures Session Replays
    Sentry.replayIntegration(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0.8,
};
